export default __webpack_public_path__ + "fonts/Circular-Medium.woff2";